<template>
  <div class="faults">
    <div class="filters">
      <Dropdown v-model="selectedStatus" :options="statusList" />
      <span class="p-input-icon-left">
        <i class="pi pi-filter" />
        <InputText type="text" v-model="filterText" placeholder="Filter" />
      </span>
    </div>
    <div class="fault_list">
      <div class="fault" v-for="f in filteredFaults" :key="f.id">
        <div class="p-d-flex p-jc-center">
          <div class="p-px-3">
            <h3 class="p-m-2">{{ f.admin }}</h3>
          </div>

          <div class="techstatus p-px-3">
            <h3 class="p-m-2">{{ f.techstatus }}</h3>
          </div>
        </div>

        <div class="desc">
          <h3 class="p-m-0">{{ f.desc }}</h3>
        </div>

        <div class="item">
          <div>Status:</div>
          <b v-if="f.status">{{ f.status }}</b>
        </div>

        <div class="created item">
          <div>Date Reported:</div>
          <b>{{ formatDate(f.created) }}</b>
        </div>

        <div class="mechanic item">
          <div>Mechanic Assigned:</div>
          <b v-if="f.mechanic"
            >{{ f.mechanic.rank }} {{ f.mechanic.lastname }},
            {{ f.mechanic.firstname }}
          </b>
          <b v-else class="assigned item">Not assigned</b>
        </div>

        <div class="repairstatus item">
          <div>Status of Repair:</div>
          <b>{{ f.repairstatus || "..." }}</b>
        </div>

        <div class="selector p-mb-3">
          <router-link
            tag="div"
            class="edit p-shadow-8"
            :to="'/myfaults/' + f.id"
            >Edit Fault</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fb_db, fs, fb_users, fb_auth } from "../firebase";
import { format } from "date-fns";
import Dropdown from "primevue/dropdown";

export default {
  name: "NewFaults",
  components: {
    // Dialog,
    Dropdown,
  },
  data() {
    return {
      faults: [],
      confirmRemoveDialog: false,
      filterText: "",
      selectedStatus: "All",
      statusList: ["All", "Not Assigned", "Assigned", "Verified"],
      repairStatusList: [
        "All",
        "In Process",
        "Parts Required",
        "Additonal Time",
        "Repairs Complete",
        "Could Not Validate",
      ],
      options: [
        {
          name: "Assigned",
          code: 2,
        },
        {
          name: "Verified",
          code: 3,
        },
        {
          name: "All",
          code: 4,
        },
      ],
    };
  },
  async mounted() {
    await this.getMyFaults();
  },
  methods: {
    async getMyFaults() {
                let now = new Date();
          now.setDate(now.getDate()-7);
      this.loading = true;
      const docs = await fb_db
        .collection("faults")
        .where("user", "==", fb_users.doc(fb_auth.currentUser.uid))
        .where("created",">",now)
        .get()
        .then((docs) => {
          this.faults = [];
          docs.forEach(async (doc) => {
            let item = doc.data();
            item.id = doc.id;
            let user = await item.user.get();
            item.user = user.data();
            if (item.mechanic) {
              console.debug("loading mech");
              let mech = await item.mechanic.get();
              item.mechanic = mech.data();
            }
            this.faults.push(item);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error("error getting faults: ", error);
        });
    },

    formatDate(date) {
      let dt = date.toDate();
      return format(dt, "HH:mm MM/DD/YYYY");
    },
  },
  computed: {
    filteredFaults() {
      return this.faults.filter((f) => {
        if (this.selectedStatus == "All") {
          return (
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } else if (this.selectedStatus == "Assigned") {
          return (
            f.status == "Assigned" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        }  else if (this.selectedStatus == "Not Assigned") {
          return (
            f.status == "Not Assigned" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } else if (this.selectedStatus == "Verified") {
          return (
            f.status == "Verified" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.faults {
  .fault_list {
    .fault {
      width: 300px;

      background: #efefef;
      border-radius: 10px;
      margin: 10px;
      float: left;

      div {
        margin: 0px 5px;
        padding: 5px 15px;
        border-radius: 5px;
        // color: $white;
      }

      .edit {
        background: $accent;
        // color: $text;
        cursor: pointer;
      }

      .delete {
        background: $primary;
        // color: $white;
        cursor: pointer;
      }

      .item {
        padding: 5px;
        text-align: left;

        b {
          margin-left: 25px;
        }

        div {
          font-size: 14px;
        }
      }

      .admin {
      }

      .techstatus {
        color: red;
        font-size: 25px;
      }

      .desc {
        color: #000000;
      }

      .verify {
      }

      .repairstatus {
      }

      .user {
        color: black;
      }

      .created {
      }

      .mechanic {
      }

      .assigned {
        color: #FFCC5C;
      }
    }
  }
}
</style>